<div style="text-align: center; margin-top:10%">
    <p style="font-size: 30px ; color: #002b5c;">Page not found or access denied <br> 
        <span style="font-size: 20px;">Please contact the system administrator</span>
    </p>
</div>

